<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/newdefault'
    import Spinner from '@components/spinner'
    import { giftlistApi } from '@router/apiFiles/giftlistApi'
    import { productApi } from '@router/apiFiles/productApi'
    import { priceApi } from '@router/apiFiles/priceApi'
    import { vtexProductApi } from '@router/apiFiles/vtexProductApi'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Lista de presentes',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout, Spinner
        },
        data() {
            return {
                title: 'Lita de Presentes',
                items: [
                    {
                        text: 'Sistema',
                        href: '/',
                    },
                    {
                        text: 'Paginas',
                        href: '/',
                    },
                    {
                        text: 'Home',
                        active: true,
                    },
                ],
                isMaster: false,
                id: '',
                externalId: '',
                description: '',
                city: '',
                date: '',
                daysCountdown: '',
                products: [],
                page: 1,
                endOfPage: false,
                isBusy: false,
                orderBy: 'OrderByNameAsc',
                inStore: false,
                scTimer: 0,
                scY: 0,
            }
        },
        mounted() {
            this.fetchData();
            this.scroll();
            if (window.localStorage.getItem('instore') == 'true') this.inStore = true;
            window.addEventListener('scroll', this.handleScroll);

            if (this.$route && this.$route.query) {
                if (this.$route.query.newcheckout) {
                    this.newcheckout = this.$route.query.newcheckout == 'true';
                }
                else this.newcheckout = false;
            }   

        },
        methods: {
            scroll() {
                var self = this;
                window.onscroll = () => {
                    //let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
                    let bottomOfWindow = (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) >= (document.documentElement.offsetHeight * 0.9)
                    if (bottomOfWindow && !self.isBusy) {
                        self.populateProducts();
                    }
                }
            },
            async fetchData() {
                var self = this;
                //this.getListByUrl(self.$route.params.urlText);
                giftlistApi
                    .getGiftlistByUrl({ url: self.$route.params.urlText })
                    .then(function (data) {
                        self.description = data.data.members;
                        self.city = data.data.city;
                        self.date = data.data.date;
                        self.id = data.data.id;
                        self.externalId = data.data.externalId;
                        self.page = 1;
                        self.endOfPage = false;
                        self.products = [];
                        self.populateProducts();
                    })
            },
            async getListByUrl(urlText) {
                console.log('param received:' + urlText)
            },
            async populateProducts() {
                var self = this;
                if (self.id == '' || self.endOfPage == true) return;
                self.isBusy = true;

                giftlistApi.getProductsPagedOrdered({ giftlistId: self.id, page: self.page, order: self.orderBy }).then(function (data) {
                    if (data.data.length == 0) {
                        self.endOfPage = true;
                        self.isBusy = false;
                        return;
                    }
                    var prodlist = data.data;
                    self.page++;
                    self.isBusy = false;

                    prodlist.forEach((item) => {
                        item.description = '';
                        item.imageUrl = '';
                        item.refCode = '';
                        item.hasListPrice = '';
                        item.listPrice = '';
                        item.price = '';
                        self.products.push(item);

                        productApi.GetProduct({ skuid: item.skuid }).then(function (data) {
                            item.description = data.data.description;
                            item.imageUrl = data.data.imageUrl;
                            item.refCode = data.data.refCode;
                        });

                        priceApi.GetPrice({ skuid: item.skuid }).then(function (data) {
                            if (data == null || typeof (data) == 'undefined' || typeof (data.data) == 'undefined') {
                                productApi.GetProductComplete({ skuid: item.skuid }).then(function (data) {
                                    item.description = data.description;
                                    item.imageUrl = data.imageUrl;
                                    item.refCode = data.reference;
                                    item.hasListPrice = data.hasListPrice;
                                    item.listPrice = data.listPrice;
                                    item.price = data.price;
                                }, function (error) {
                                    //remove product
                                    self.removeProduct(item.skuid);
                                });
                                return;
                            }
                            item.hasListPrice = data.data.hasListPrice;
                            item.listPrice = data.data.listPrice;
                            item.price = data.data.price;
                        }, function (error) {
                            productApi.GetProductComplete({ skuid: item.skuid }).then(function (data) {
                                item.description = data.description;
                                item.imageUrl = data.imageUrl;
                                item.refCode = data.reference;
                                item.hasListPrice = data.hasListPrice;
                                item.listPrice = data.listPrice;
                                item.price = data.price;
                            }, function (error) {
                                //remove product
                                self.removeProduct(item.skuid);
                            });
                        });

                        /*
                        productApi.GetProductComplete({ skuid: item.skuid }).then(function(data) {
                          item.description = data.description;
                          item.imageUrl = data.imageUrl;
                          item.refCode = data.reference;
                          item.hasListPrice = data.hasListPrice;
                          item.listPrice = data.listPrice;
                          item.price = data.price;
                          //self.products.push(item);
                        }, function(error2) {
                          productApi.GetProduct({ skuid: item.skuid }).then(function(data) {
                            item.description = data.data.description;
                            item.imageUrl = data.data.imageUrl;
                            item.refCode = data.data.refCode;
                          });
                          priceApi.GetPrice({ skuid: item.skuid }).then(function(data) {
                            item.hasListPrice = data.data.hasListPrice;
                            item.listPrice = data.data.listPrice;
                            item.price = data.data.price;
                          });
                        });*/

                    });

                })
            },
            generateBuyLink(product) {
                var imagelink = product.imageUrl.split('/arquivos/ids/')[1];
                var price = product.price.replace("R$", "").replace(".", "").replace(" ", "").replace(",", ".");
                price = parseFloat(price);
                var listPrice = null;
                if (product.hasListPrice) {
                    listPrice = product.price.replace("R$", "").replace(".", "").replace(" ", "").replace(",", ".");
                    listPrice = parseFloat(listPrice);
                }
                var self = this;
                //g:self.externalId
                var cartdata = { i: self.id, n: self.description, p: [{ id: product.skuid, n: product.description, u: '', i: imagelink, p: price, l: listPrice, q: 1 }] };
                if (this.inStore == true) cartdata.s = true;
                var urltobuy = "https://listas.lavillecasa.com.br/checkout/cart?token=" + btoa(JSON.stringify(cartdata));
                var newurltobuy = "/checkout/cart?token=" + btoa(JSON.stringify(cartdata));
                if (this.newcheckout == true) urltobuy = newurltobuy;
                return urltobuy;
            },
            removeProduct(skuid) {
                var self = this;
                for (var prodIndex = 0; prodIndex < self.products.length; prodIndex++) {
                    if (self.products[prodIndex].skuid == skuid) {
                        self.products.splice(prodIndex, 1);
                        console.log('removed:' + skuid);
                        break;
                    }
                }
            },
            handleScroll: function () {
                if (this.scTimer) return;
                this.scTimer = setTimeout(() => {
                    this.scY = window.scrollY;
                    clearTimeout(this.scTimer);
                    this.scTimer = 0;
                }, 100);
            },
            toTop: function () {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
        },
        watch: {
            orderBy: function (newValue, oldValue) {
                var self = this;
                self.page = 1;
                self.endOfPage = false;
                self.products = [];
                self.populateProducts();
            }
        }
    }
</script>

<template>
    <Layout>

        <div class="ext info-lista">
            <div class="int">
                <div class="giftlist giftlistinfo giftlisttype-41">
                    <input type="hidden" id="shelf-body-class" value="giftlisttype-41">
                    <h3 class="giftlistinfo-title" style="display: block;">presentes</h3>
                    <div class="giftlistinfo-image">
                        <img class="giftlistinfo-picture" height="400" width="400" alt="" src="/img/no-image.jpg" />
                    </div>
                    <div class="giftlistinfo-members">
                        <h3 class="new-info-name"> {{description}}</h3>
                        <div class="giftlistinfo-event">
                            <span class="event-title">Evento</span>
                            <ul class="">
                                <li class="city state">LOCAL: {{city}}</li>
                                <li class="date">DATA: {{date}}</li>
                            </ul>
                        </div>
                    </div>
                    <span class="giftlistinfo-message no-message"></span>
                    <div style="display: none;" class="giftlistinfo-event-countdown countdown-week-0">
                        <span class="days-info">Faltam</span>
                        <span class="days"><strong>{{daysCountdown}}</strong> dias</span>
                    </div>
                </div>
            </div>
        </div>



        <div id="gcontent" class="ext pdpto">
            <div class="int">

                <div class="form-inline float-sm-right">
                    <b-form-select inline v-model="orderBy" class="m-3 float-right">
                        <option value="OrderByNameAsc">Ordernar de A - Z</option>
                        <option value="OrderByNameDesc">Ordernar de Z - A</option>
                        <option value="OrderByPriceAsc">Ordernar pelo menor preço </option>
                        <option value="OrderByPriceDesc">Ordernar pelo maior preço </option>
                    </b-form-select>
                </div>

                <div class="lista-produtos">
                    <div class="gt-produtos">
                        <div class="main">
                            <div class="vitrine resultItemsWrapper">
                                <div id="ResultItems_46052188" class="gt-vitrine prateleira">
                                    <div class="gt-vitrine prateleira n4colunas">
                                        <ul>


                                            <template v-for="(product, index) in products">
                                                <li :key="index" v-show="product.price != '' && product.imageUrl != ''">
                                                    <div class="fotoProduto">
                                                        <a href="javascript:void(0)" v-bind:rel="product.skuid" class="espiar-produto">
                                                            <img v-bind:src="product.imageUrl" width="370" height="370" v-bind:alt="product.skuid" id="">
                                                        </a>
                                                        <div class="show-buy">
                                                            <div class="add-list">
                                                                <div v-show="product.price.length > 0 && !(product.won >= product.wanted && product.won > 0)" class="buy-button-normal buy-button-all bb-count-1" id="55923" name="55923">
                                                                    <a class="buy-button-normal-a55923 buy-button-all-a55923" v-bind:href="generateBuyLink(product)" v-bind:title="product.description">
                                                                        <span class="buy-all buy-giftlist">Comprar</span>
                                                                        <span class="buy-sku-name">{{product.description}}</span>
                                                                    </a>
                                                                    <input type="hidden" value="cart" class="buy-button-normal-go-to-cart-55923 buy-button-all-go-to-cart-55923">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h3 class="nome"><a>{{product.description}}</a></h3>
                                                    <div class="refProd">
                                                        <div class="product-field product_field_31 product-field-type_1">
                                                            Referencia
                                                            <ul><li v-bind:class="product.refCode">{{product.refCode}}</li></ul>
                                                        </div>
                                                    </div>
                                                    <div class="preco">
                                                        <span v-if="product.hasListPrice" class="preco-de">{{product.listPrice}}</span>
                                                        <span class="preco-por">{{product.price}}</span>
                                                    </div>
                                                    <div class="produtos-disponiveis d-verificado">
                                                        <span class="comprados">comprados <b>{{product.won}}</b></span>
                                                        <span>/</span>
                                                        <span class="desejados">solicitados <b>{{product.wanted}}</b></span>
                                                        <span class="atingidos jaganhou" v-show="product.won >= product.wanted && product.won > 0">Já ganhou!</span>
                                                        <span class="atingidos ganhouparcial" v-show="product.won < product.wanted && product.won > 0">Ganhou parcialmente!</span>
                                                    </div>
                                                </li>
                                                <li v-if="(index + 1) % 4 == 0" :key="`${index}-divider`" class="helper_divider"></li>
                                            </template>

                                            <div style="height: 50px;" class="w-100">
                                                <Spinner :loading="isBusy" />
                                            </div>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- lista produtos -->
                </div>
            </div>
        </div>

        <transition name="fade">
            <div id="pagetop" class="fixed text-center" v-show="scY > 300" @click="toTop">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                     stroke="#4a5568"
                     stroke-width="1" stroke-linecap="square" stroke-linejoin="arcs" role="button">
                    <path d="M18 15l-6-6-6 6" />
                </svg>
            </div>
        </transition>


    </Layout>
</template>

<style lang="scss">
  @import '../../../../designScoped/giftlist.scss';
  @import '../../../../designScoped/shelf.scss';
</style>

<style lang="scss" scoped>


.ext {
  text-align: center;
}

.ext,.line {
    float: none;
    clear: both
}

.int {
  margin: 0 auto;
  text-align: left;
  position: relative;
  max-width: 1170px;
}

#gcontent {
  padding: 20px;
  width:100%;
}

</style>

